import SvgIcon from '@Web/Src/Components/SvgIcon';

function TutorialItem({ item, selected, setSelected }) {
    return (
        <div
            onClick={() => setSelected(item)}
            className={`${selected.title === item.title ? 'text-blue bg-light' : 'text-light'} mt-4 flex cursor-pointer items-center justify-between gap-1 rounded-lg bg-[#171A20] px-4 py-3.5 font-semibold`}
        >
            <h3 className='flex items-center gap-2'>
                <SvgIcon
                    className='!size-6 min-w-6'
                    collectionName='header-icons-sprite'
                    iconId={'video-list'}
                />
                {item.title}
            </h3>
            <SvgIcon
                className='!size-6 min-w-6'
                collectionName='header-icons-sprite'
                iconId={'arrow-link'}
            />
        </div>
    );
}

export default TutorialItem;
